export default __webpack_public_path__ + "static/media/supply_accounts_import_template.f7322216.csv";